import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

const Services = ({serve}) => {
    const {id,name,img,about,price}=serve;

   const navigate =useNavigate();
   const serviceDetails =(id)=>{
       navigate("/checkout")
   }
   return(
        <div className='services'>
            <img className='img-fluid'style={{height:"350px"}} src={img} alt=""/>
            <h2 className='p-2'>Name:{name}</h2>
            <p className='fw-bold pb-2'>Description:{about}</p>
            <h4> Price:{price}</h4>
            <button onClick={() =>serviceDetails("/login")} className='primary'>Checkout</button>
        </div>
    




      
   );
};

export default Services;